import { Switch, FormControlLabel, FormControl, Grid, FormHelperText } from '@material-ui/core';
import { useField } from 'formik';
import React, { useMemo } from 'react';
export const FormikSwitch = props => {
    let { label, name, grid } = props;
    const [field, meta, { setValue }] = useField(props);
    if (!grid) {
        // default field  to expand entire width of the form
        grid = { xs: 12 };
    }
    return useMemo(() => (React.createElement(Grid, Object.assign({ item: true }, grid),
        React.createElement(FormControl, { name: name, error: meta.touched && Boolean(meta.error), component: 'fieldset' },
            React.createElement(FormControlLabel, { control: React.createElement(Switch, Object.assign({ "aria-label": label }, field, { name: name, color: 'primary', onChange: event => {
                        setValue(event.target.checked);
                    } })), value: meta.value, checked: meta.value, label: label, labelPlacement: 'end' })),
        meta.error && React.createElement(FormHelperText, null, meta.error))), [field.value, meta.error, name, label]);
};
export default FormikSwitch;
//# sourceMappingURL=FormikSwitch.js.map